export default {
  path: '/storage',
  name: 'storage',
  component: () => import('@/views/storage/Index'),
  redirect: { name: 'storage-climbing-equipment' },
  children: [
    {
      path: 'climbing-equipment',
      name: 'storage-climbing-equipment',
      component: () => import('@/views/storage/ClimbingEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'kitchen-equipment',
      name: 'storage-kitchen-equipment',
      component: () => import('@/views/storage/KitchenEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'climbing-electronics',
      name: 'storage-climbing-electronics',
      component: () => import('@/views/storage/ClimbingElectronics'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'medications-equipment',
      name: 'storage-medications-equipment',
      component: () => import('@/views/storage/MedicationEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'oxygen-gas',
      name: 'storage-oxygen-gas',
      component: () => import('@/views/storage/OxygenGas'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'dicts',
      name: 'storage-dicts',
      component: () => import('@/views/storage/Dicts'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
  ],
}